import { ZERO_BIG_NUMBER } from '@ui/lib/bignumber';
import { TradePair } from '@ui/types/tradePair';
import { useMemo } from 'react';

import { useTradePairInfosByPairBaseSymbol } from './useTradePairInfos';

export const useTradePairBaseQtyInfo = (tradingPair: TradePair) => {
  const tradingPairsInBaseSymbol = useTradePairInfosByPairBaseSymbol(
    tradingPair.baseSymbol,
  );

  return useMemo(
    () =>
      tradingPairsInBaseSymbol?.reduce(
        (acc, pair) => {
          acc.longQtySum = acc.longQtySum.plus(pair.longQty ?? ZERO_BIG_NUMBER);
          acc.shortQtySum = acc.shortQtySum.plus(
            pair.shortQty ?? ZERO_BIG_NUMBER,
          );
          acc.totalQtySum = acc.longQtySum.plus(acc.shortQtySum);

          return acc;
        },
        {
          longQtySum: ZERO_BIG_NUMBER,
          shortQtySum: ZERO_BIG_NUMBER,
          totalQtySum: ZERO_BIG_NUMBER,
        },
      ),
    [tradingPairsInBaseSymbol],
  );
};
